var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = function(msg) {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5896: function() { return loadStrictVersionCheckFallback("default", "@azure/msal-browser", [1,2,30,0], function() { return __webpack_require__.e(4918).then(function() { return function() { return __webpack_require__(4918); }; }); }); },
	4082: function() { return loadStrictVersionCheckFallback("default", "@emotion/react", [1,11,10,5], function() { return Promise.all([__webpack_require__.e(3361), __webpack_require__.e(6192)]).then(function() { return function() { return __webpack_require__(6702); }; }); }); },
	8803: function() { return loadStrictVersionCheckFallback("default", "@mui/system", [1,5,10,12], function() { return Promise.all([__webpack_require__.e(3361), __webpack_require__.e(2556), __webpack_require__.e(3751), __webpack_require__.e(4082), __webpack_require__.e(2945)]).then(function() { return function() { return __webpack_require__(7528); }; }); }); },
	5773: function() { return loadSingletonVersionCheckFallback("default", "react-dom", [1,18,2,0], function() { return function() { return __webpack_require__(4164); }; }); },
	2945: function() { return loadStrictVersionCheckFallback("default", "@emotion/styled", [1,11,10,5], function() { return __webpack_require__.e(3938).then(function() { return function() { return __webpack_require__(225); }; }); }); },
	4920: function() { return loadStrictVersionCheckFallback("default", "@mui/material", [1,5,10,12], function() { return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(3460), __webpack_require__.e(9124), __webpack_require__.e(899), __webpack_require__.e(4750), __webpack_require__.e(8980), __webpack_require__.e(4141), __webpack_require__.e(8546), __webpack_require__.e(2556), __webpack_require__.e(9998), __webpack_require__.e(8803), __webpack_require__.e(5773), __webpack_require__.e(4082), __webpack_require__.e(2945)]).then(function() { return function() { return __webpack_require__(9998); }; }); }); },
	8337: function() { return loadStrictVersionCheckFallback("default", "moment", [1,2,30,1], function() { return __webpack_require__.e(2426).then(function() { return function() { return __webpack_require__(2426); }; }); }); },
	8327: function() { return loadStrictVersionCheckFallback("default", "powerbi-client", [1,2,22,3], function() { return __webpack_require__.e(6158).then(function() { return function() { return __webpack_require__(6158); }; }); }); },
	4305: function() { return loadStrictVersionCheckFallback("default", "react-i18next", [1,12,0,0], function() { return __webpack_require__.e(9230).then(function() { return function() { return __webpack_require__(9230); }; }); }); },
	2846: function() { return loadStrictVersionCheckFallback("default", "react-router-dom", [1,6,4,2], function() { return __webpack_require__.e(3613).then(function() { return function() { return __webpack_require__(3613); }; }); }); },
	190: function() { return loadStrictVersionCheckFallback("default", "@azure/msal-react", [1,1,4,9], function() { return Promise.all([__webpack_require__.e(8302), __webpack_require__.e(5896)]).then(function() { return function() { return __webpack_require__(8302); }; }); }); },
	2789: function() { return loadStrictVersionCheckFallback("default", "moment-timezone", [2,0,5,45], function() { return Promise.all([__webpack_require__.e(3528), __webpack_require__.e(8337)]).then(function() { return function() { return __webpack_require__(3528); }; }); }); },
	5701: function() { return loadStrictVersionCheckFallback("default", "@mui/x-data-grid", [1,5,17,9], function() { return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(9124), __webpack_require__.e(899), __webpack_require__.e(4750), __webpack_require__.e(8980), __webpack_require__.e(4141), __webpack_require__.e(8546), __webpack_require__.e(9298), __webpack_require__.e(4920), __webpack_require__.e(8803), __webpack_require__.e(5773)]).then(function() { return function() { return __webpack_require__(9746); }; }); }); },
	1282: function() { return loadStrictVersionCheckFallback("default", "react-calendar", [1,4,2,1], function() { return __webpack_require__.e(7040).then(function() { return function() { return __webpack_require__(7040); }; }); }); },
	9734: function() { return loadStrictVersionCheckFallback("default", "powerbi-client-react", [1,1,4,0], function() { return __webpack_require__.e(3724).then(function() { return function() { return __webpack_require__(3724); }; }); }); },
	4941: function() { return loadStrictVersionCheckFallback("default", "@mui/icons-material", [1,5,10,9], function() { return Promise.all([__webpack_require__.e(4223), __webpack_require__.e(2610), __webpack_require__.e(8803)]).then(function() { return function() { return __webpack_require__(2610); }; }); }); },
	5166: function() { return loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], function() { return function() { return __webpack_require__(2791); }; }); }
};
var initialConsumes = [5166];
initialConsumes.forEach(function(id) {
	__webpack_require__.m[id] = function(module) {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"190": [
		190
	],
	"386": [
		1282
	],
	"2181": [
		9734
	],
	"2846": [
		2846
	],
	"2945": [
		2945
	],
	"4082": [
		4082
	],
	"4299": [
		2789
	],
	"4305": [
		4305
	],
	"4920": [
		4920
	],
	"5701": [
		5701
	],
	"5773": [
		5773
	],
	"5896": [
		5896
	],
	"7256": [
		4941
	],
	"8327": [
		8327
	],
	"8337": [
		8337
	],
	"8803": [
		8803
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}